"use strict";

exports.__esModule = true;
exports.STATE_EDGE_ROW_RATIO = exports.STATE_EDGE_RATIO = exports.STATE_EDGE_MIN = exports.STATE_EDGE_MAX = exports.STATE_EDGE_CSS = void 0;
exports.stateEdgeSize = stateEdgeSize;
// The state-coloured edge on cards and rows scales with the element it sits
// on, so it reads from across the floor on a wall display, but never thins
// below the floor on a small card.
var STATE_EDGE_RATIO = exports.STATE_EDGE_RATIO = 0.025; // of the element's width
var STATE_EDGE_ROW_RATIO = exports.STATE_EDGE_ROW_RATIO = 0.125; // of a table row's height
var STATE_EDGE_MIN = exports.STATE_EDGE_MIN = 6;
var STATE_EDGE_MAX = exports.STATE_EDGE_MAX = 24;
function stateEdgeSize(reference, ratio) {
  if (ratio === void 0) {
    ratio = STATE_EDGE_RATIO;
  }
  return Math.round(Math.min(STATE_EDGE_MAX, Math.max(STATE_EDGE_MIN, reference * ratio)));
}

// The same rule as CSS, for elements whose size is not known in JS.
var STATE_EDGE_CSS = exports.STATE_EDGE_CSS = "clamp(" + STATE_EDGE_MIN + "px, " + STATE_EDGE_RATIO * 100 + "%, " + STATE_EDGE_MAX + "px)";